import { ComponentProps } from 'react';
import Button from '@alltrails/denali/components/Button';
import FormattedMessage from '../FormattedMessage';

type CreateRouteButtonProps = Pick<ComponentProps<typeof Button>, 'variant'>;

const CreateRouteButton = ({ variant }: CreateRouteButtonProps) => {
  return (
    <Button
      linkInfo={{
        href: '/explore/custom-routes/new?trigger=nav'
      }}
      size="sm"
      text={<FormattedMessage defaultMessage="Create route" />}
      variant={variant}
    />
  );
};

export default CreateRouteButton;
